export const handleTabDelimitedText = (e) => {
  e.preventDefault()
  const { selectionStart, selectionEnd, value } = e.target
  e.target.value =
    value.substring(0, selectionStart) + '\t' + value.substring(selectionEnd)
  e.target.selectionStart = e.target.selectionEnd = selectionStart + 1
  return e
}
